import {DomainEvent} from './DomainEvent';
import {CupTeamSeason} from '../resources/CupTeamSeason';

export class CupTeamSeasonDeleted extends DomainEvent<CupTeamSeason> {
}
